export const BOOLEAN_OPTIONS = [
  { title: 'null', value: null },
  { title: 'false', value: false },
  { title: 'true', value: true },
];
